import { getCurrentEnvironment } from '../apiEndpoint/apiEndpoint.js';

var _window$location;
getCurrentEnvironment((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) === 'test';
var languageCodeToLanguage = function languageCodeToLanguage(code) {
  switch (code) {
    case 'dk':
      return 'danish';
    case 'de':
      return 'german';
    case 'uk':
      return 'english';
    case 'fr':
      return 'french';
    case 'frbe':
      return 'french';
    case 'nlbe':
      return 'dutch';
    case 'nl':
      return 'dutch';
    case 'no':
      return 'norwegian';
    case 'fi':
      return 'finnish';
    case 'se':
      return 'swedish';
    default:
      return 'swedish';
  }
};

export { languageCodeToLanguage };
